module.exports = __webpack_public_path__ + "static/img/logo.b1bf463.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/header1/img/logo.png
// module id = 306
// module chunks = 40 41 42